var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 0C5.95436 0 4.30773 1.64663 4.30773 3.69231V6.15385C2.95436 6.15385 1.84619 7.26202 1.84619 8.61539V13.5385C1.84619 14.8918 2.95436 16 4.30773 16H11.6923C13.0457 16 14.1539 14.8918 14.1539 13.5385V8.61539C14.1539 7.26202 13.0457 6.15385 11.6923 6.15385V3.69231C11.6923 1.64663 10.0457 0 8.00004 0ZM8.00004 1.23077C9.40148 1.23077 10.4616 2.29087 10.4616 3.69231V6.15385H5.5385V3.69231C5.5385 2.29087 6.5986 1.23077 8.00004 1.23077ZM8.00004 9.23077C8.67792 9.23077 9.23081 9.78365 9.23081 10.4615C9.23081 10.8918 8.98562 11.3149 8.61542 11.5V12.9231C8.61542 13.2933 8.37023 13.5385 8.00004 13.5385C7.62985 13.5385 7.38465 13.2933 7.38465 12.9231V11.5C7.01446 11.3149 6.76927 10.8918 6.76927 10.4615C6.76927 9.78365 7.32215 9.23077 8.00004 9.23077Z",
    fill: "#03F5AE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ff8835d7abac1fb4ffb4f31e18dc35e6.svg";
export { ForwardRef as ReactComponent };